import Country from "@bimproject/country";

import Select from "./Select";

// Single-country picker. Value is an ISO 3166-1 alpha-3 code — the format
// `@bimproject/country` and the backend both speak.
const OPTIONS: { label: string; value: string }[] = Country
    .all()
    .map((code) => ({ label: Country.fromCode(code).name, value: code }))
    .sort((a, b) => a.label.localeCompare(b.label));

export default function CountrySelect({
    value,
    onChange,
    isDisabled,
    placeholder = "Select a country…",
}: {
    value: string
    onChange: (value: string) => void
    isDisabled?: boolean
    placeholder?: string
}) {
    const options = [{ label: placeholder, value: "" }, ...OPTIONS];

    return (
        <Select
            isDisabled={ isDisabled }
            onSelect={ (code: string) => onChange(code || undefined) }
            options={ options }
            placeholder={ placeholder }
            value={ value ?? "" }
        />
    );
}
